module.exports = __webpack_public_path__ + "static/img/pro-2-220x294.ed4af0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-2-220x294.jpg
// module id = qXLn
// module chunks = 1